import React from 'react';

import { ISVGPersonalProps } from 'types/svg';

export const undraft: ISVGPersonalProps = {
  viewBox: '0 0 28 28',
  content: (
    <g id="undraft_icon_active" data-name="undraft icon active" transform="translate(18459.691 2947.492)">
      <rect
        id="Rectangle_2788"
        data-name="Rectangle 2788"
        width="28"
        height="28"
        transform="translate(-18459.691 -2947.492)"
        fill="none"
      />
      <g id="Group_4034" data-name="Group 4034" transform="translate(2.904 1.653)">
        <path
          id="Path_7145"
          data-name="Path 7145"
          d="M9.019,18.985A.635.635,0,0,1,8.569,17.9l9.79-9.788a1.877,1.877,0,0,0,.566-1.338,1.9,1.9,0,0,0-.566-1.359L14.78,1.836a1.9,1.9,0,0,0-1.352-.568,1.869,1.869,0,0,0-1.335.564L1.837,12.082a1.877,1.877,0,0,0-.566,1.338,1.9,1.9,0,0,0,.566,1.359L4.961,17.9a.635.635,0,1,1-.9.9L.94,15.676A3.158,3.158,0,0,1,.91,11.21l.029-.029L11.183.938A3.131,3.131,0,0,1,13.415,0h.01a3.164,3.164,0,0,1,2.25.94l3.579,3.579a3.158,3.158,0,0,1,.029,4.466l-.029.029L9.463,18.8A.635.635,0,0,1,9.019,18.985Z"
          transform="translate(-18458.691 -2944.638)"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="0.2"
        />
        <path
          id="Path_7146"
          data-name="Path 7146"
          d="M76.364,287.007H63.159a.635.635,0,1,1,0-1.27H76.364a.635.635,0,1,1,0,1.27"
          transform="translate(-18517.34 -3212.66)"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="0.2"
        />
        <path
          id="Path_7147"
          data-name="Path 7147"
          d="M72.1,134.156a.635.635,0,0,1-.448-.185L64.476,126.8a.635.635,0,0,1,.9-.9l7.174,7.174a.635.635,0,0,1-.449,1.083Z"
          transform="translate(-18519.002 -3062.563)"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="0.2"
        />
      </g>
    </g>
  ),
};
